import { safeWindow } from '../safeWindow';

export const addDataLayer = (event: string, route: string) => {
  const window = safeWindow();

  if (!window.__env) {
    return;
  }

  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    deployName: window.__env?.DEPLOY_ENV_NAME,
    event,
    route,
  });
};
